export class OcorrenciaTipo {
  id: number;
  descricao: string;
  idSetor: number;
  prioridade: number;
}
